<template>
  <footer class="footer" id="footer">
    <div class="container-fluid">
      <nav class="float-left">
        <ul>
          <li>
            <router-link :to="{ path:'/dashboard' }">
              <i class="fa fa-home"></i> Dashboard
            </router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright float-right">
        <strong>Copyright &copy; {{ new Date().getFullYear() }} 
      <a href="http://www.roscon.com.au">Roscon Group of Companies</a>.
      </strong> All rights reserved.
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name: 'Footer'
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/Footer.vue